// extracted by mini-css-extract-plugin
export default {"articleView":"ArticleView_articleView__D1Ko1","content":"ArticleView_content__3MD3F"};